module.exports = __webpack_public_path__ + "static/media/icon-individual_leaderboard-selected.ffc2e8a4.svg";